import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mj-no-content',
  templateUrl: './noContent.component.html',
  styles: [require('./noContent.component.scss')],
})
export class NoContentComponent {
  constructor(private _router: Router) {}

  navigate() {
    this._router.navigate(['login']);
  }
}
